var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 22,
    viewBox: "0 0 143 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7586 8.42069H14.0724L11.3793 0L8.68621 8.42069H0L7.01724 13.6172L4.36207 22L11.3793 16.8034L18.3966 22L15.7034 13.5793L22.7586 8.42069Z",
    fill: "#D5D0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7586 8.42069H44.0724L41.3793 0L38.6862 8.42069H30L37.0172 13.6172L34.3621 22L41.3793 16.8034L48.3966 22L45.7034 13.5793L52.7586 8.42069Z",
    fill: "#D5D0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7586 8.42069H74.0724L71.3793 0L68.6862 8.42069H60L67.0172 13.6172L64.3621 22L71.3793 16.8034L78.3966 22L75.7034 13.5793L82.7586 8.42069Z",
    fill: "#D5D0C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.759 8.42069H104.072L101.379 0L98.6862 8.42069H90L97.0172 13.6172L94.3621 22L101.379 16.8034L108.397 22L105.703 13.5793L112.759 8.42069Z",
    fill: "#D5D0C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.759 8.42069H134.072L131.379 0L128.686 8.42069H120L127.017 13.6172L124.362 22L131.379 16.8034L138.397 22L135.703 13.5793L142.759 8.42069Z",
    fill: "#D5D0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.929beac53a011df1273deb259a383b92.svg";
export { ForwardRef as ReactComponent };